import * as React from 'react';
import QuantitySelect from '../quantity-select/quantity-select';

interface IQuantitySelectProps {
    displayText: string;
    messageText: string;
    startingAtText: string;
    priceTypeMaxError: string;
    quantity: number;
    priceTypeId: number;
    canAdd: boolean;
    canRemove: boolean;
    priceTypeMaxReached: boolean;
    onSelectQuantity: (quantity: number, priceType: number) => void;
    feeAmount?: string;
    maxQuantity?: number;
}

class PriceTypeQuantitySelect extends React.PureComponent<IQuantitySelectProps, any>{

    constructor(props) {
        super(props);
    }

    render() {
        const useTagAlert = '<use xlink:href="#icon-alert" />';

        return (
            <>
                <div className="seat-info-prices-type-list-inner">
                    <div className="seat-info-prices-type">
                        <h3 className="h6-style">{this.props.displayText}</h3>
                        {
                            this.props.startingAtText.length > 0 ?
                                <p className="caption-paragraph">{this.props.startingAtText}</p> :
                                null
                        }
                        {
                            !!this.props.feeAmount && <div className="small-italic" dangerouslySetInnerHTML={{ __html: this.props.feeAmount }} />
                        }
                        {
                            this.props.messageText.length > 0 ?
                                <p className="caption-paragraph">{this.props.messageText}</p>
                                : null
                        }

                    </div>

                    <QuantitySelect
                        componentClassName="seat-info-prices-button"
                        canAdd={this.props.canAdd}
                        canRemove={this.props.canRemove}
                        onSelectQuantity={this._onSelectQuantity}
                        quantity={this.props.quantity}
                        maxQuantity={this.props.maxQuantity}
                        arialabel={`${this.props.displayText ? (this.props.displayText + '-') : '' } ${this.props.startingAtText}`} 
                    />
                </div>

                {this.props.priceTypeMaxReached && (this.props.priceTypeMaxError !== null && this.props.priceTypeMaxError.length > 0) ?
                    <div className="ticket-selection-quantity-max-message">
                        <svg className="ticket-selection-quantity-max-alert" dangerouslySetInnerHTML={{ __html: useTagAlert }} />

                        {
                            this.isHtmlPrompt(this.props.priceTypeMaxError) ?
                                <div className="rich-text" dangerouslySetInnerHTML={{ __html: this.props.priceTypeMaxError }}></div>
                                :
                                <p>
                                    {this.props.priceTypeMaxError}
                                </p>
                        }

                    </div>
                    : null
                }

            </>);
    }

    isHtmlPrompt(message: string): boolean {
        if (message === null)
            return false;
        return message.substr(0, 4) === "<div";
    }

    _onSelectQuantity = (quantity) => {
        this.props.onSelectQuantity(quantity, this.props.priceTypeId);
    };

}

export default PriceTypeQuantitySelect;